import { render, staticRenderFns } from "./ListKidFaces.vue?vue&type=template&id=b2d32556&"
import script from "./ListKidFaces.vue?vue&type=script&lang=js&"
export * from "./ListKidFaces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports